import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useInvalidateHomeState } from '../../home/hooks/use-home-state'
import { outreachApi, outreachMessagesQueryKey, outreachStatusQueryKey } from '../api'

// Stamps messagesReviewedAt (the "Review messages" launch-checklist condition).
// Invalidates the status + messages queries so the checklist step flips green
// immediately rather than waiting for the next poll — and Home, because this
// stamp is exactly what moves the founder off the "review your messages" card
// and the sidebar CTA that reads it.
export function useReviewOutreachMessagesMutation(startupId: string) {
  const queryClient = useQueryClient()
  const invalidateHome = useInvalidateHomeState(startupId)
  return useMutation({
    mutationFn: () => outreachApi.reviewMessages(startupId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: outreachStatusQueryKey(startupId) })
      await queryClient.invalidateQueries({ queryKey: outreachMessagesQueryKey(startupId) })
      await invalidateHome()
    },
  })
}
